import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const IntegrationsListPage = lazy(() => import('./IntegrationsListPage'));
const IntegrationDetailPage = lazy(() => import('./IntegrationDetailPage'));

export const integrationRoutes: RouteObject[] = [
  {
    path: 'integrations',
    element: (
      <ProtectedRoute action="integrations:view">
        <IntegrationsListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'integrations/:id',
    element: (
      <ProtectedRoute action="integrations:view">
        <IntegrationDetailPage />
      </ProtectedRoute>
    ),
  },
];
